import { Input, theme, typographyRem } from '@by-miles/bymiles-styles'
import { postcodeRegex } from '@by-miles/regex'
import React, { useState } from 'react'
import styled from 'styled-components'

import { AddressInput } from '../../../../../generated/graphql'
const { textLink: TextLink } = typographyRem

interface EnterAddressManuallyProps {
  onChange: (value: AddressInput) => void
  findDifferentAddress: () => void
  preFilled?: AddressInput
  error: boolean
  showModal: boolean
}

const ManualAddressStyle = styled.div`
  .address-input {
    &:last-child {
      margin-bottom: ${theme.grid.spacing.s}px;
    }
    &:not(:last-child) {
      margin-bottom: ${theme.grid.spacing.xs}px;
    }
  }
  form {
    .postcode-input {
      input {
        text-transform: uppercase;
      }
    }
  }
`

export const EnterAddressManually = ({
  onChange,
  findDifferentAddress,
  preFilled,
  error,
  showModal,
}: EnterAddressManuallyProps) => {
  const [manualAddress, setManualAddress] = useState<AddressInput>(
    preFilled || {
      line_2: '',
      line_3: '',
      country: 'uk',
      county: '',
    },
  )

  const handleOnChange = (value: string, target: string) => {
    const updatedAddress = { ...manualAddress, [target]: value }
    setManualAddress(updatedAddress)
    onChange(updatedAddress)
  }
  return (
    <ManualAddressStyle>
      <div>
        <Input
          placeHolder="Address line 1"
          name="line-one"
          value={manualAddress?.line_1 || ''}
          onChange={value => handleOnChange(value, 'line_1')}
          errorNoMessage={error && !manualAddress?.line_1}
          valid={!!manualAddress?.line_1}
          dataCy="address-line-one-input"
          className="address-input"
          autoComplete="street-address"
          tabFocusTrap={showModal ? -1 : 0}
        />
        <Input
          placeHolder="Address line 2"
          name="line-two"
          value={manualAddress?.line_2 || ''}
          onChange={value => handleOnChange(value, 'line_2')}
          valid={!!manualAddress?.line_2}
          dataCy="address-line-two-input"
          isOptional
          className="address-input"
          autoComplete="address-line2"
          tabFocusTrap={showModal ? -1 : 0}
        />
        <Input
          placeHolder="Address line 3"
          name="line-three"
          value={manualAddress?.line_3 || ''}
          onChange={value => handleOnChange(value, 'line_3')}
          valid={!!manualAddress?.line_3}
          dataCy="address-line-three-input"
          isOptional
          className="address-input"
          autoComplete="address-line3"
          tabFocusTrap={showModal ? -1 : 0}
        />
        <Input
          placeHolder="Town/city"
          name="city"
          value={manualAddress?.city || ''}
          onChange={value => handleOnChange(value, 'city')}
          errorNoMessage={error && !manualAddress?.city}
          valid={!!manualAddress?.city}
          dataCy="city-input"
          className="address-input"
          autoComplete="address-level2"
          tabFocusTrap={showModal ? -1 : 0}
        />
        <Input
          placeHolder="Postcode"
          name="postcode"
          value={manualAddress?.postcode || ''}
          onChange={value => handleOnChange(value.replaceAll(' ', ''), 'postcode')}
          errorNoMessage={
            (error && !manualAddress?.postcode) ||
            (manualAddress?.postcode && !manualAddress?.postcode?.match(postcodeRegex)) ||
            false
          }
          valid={!!manualAddress?.postcode?.match(postcodeRegex)}
          dataCy="postocde-input"
          className="address-input postcode-input"
          autoComplete="postal-code"
          tabFocusTrap={showModal ? -1 : 0}
        />
      </div>
      <TextLink onClick={() => findDifferentAddress()}>Find a different address</TextLink>
    </ManualAddressStyle>
  )
}
